import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const ProtectedRoute = ({ children, permission }) => {
  const navigate = useNavigate();

  const userAuth = localStorage.getItem("authToken");
  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
  const isAuthenticated = !!userAuth;
  const unauthorized =
    isAuthenticated && permission && !permissions.includes(permission);

  useEffect(() => {
    // Not logged in
    if (!isAuthenticated) {
      navigate("/login", { replace: true });
      return;
    }

    // Logged in but no permission
    if (unauthorized) {
      const timer = setTimeout(() => {
        navigate(-1); // Go back
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, unauthorized, navigate]);

  // Don't render anything while redirecting to login
  if (!isAuthenticated) {
    return null;
  }

  // Show unauthorized message
  if (unauthorized) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <h2>Unauthorized Access</h2>
        <p>This page is not assigned to you.</p>
        <p>Please contact your administrator to request access.</p>
        <p>Redirecting back...</p>
      </div>
    );
  }

  return children;
};